import { Placeholder } from "react-bootstrap";

function TableRowPlaceholder({ rowHeight, columns, idx, tableName }) {
  return (
    <tr
      key={idx}
      id={tableName + "-table-row-" + idx}
      className="text-center align-middle"
      style={{ height: rowHeight }}
    >
      {columns.map((column) => (
        <Placeholder as="td" animation="glow" key={column.accessor}>
          <Placeholder size="sm" xs={10} style={{ margin: ".5rem 0 .5rem" }} />
        </Placeholder>
      ))}
    </tr>
  );
}

export default TableRowPlaceholder;
